/**
 * useMLInsightsNotifications Hook
 *
 * Sistema de notificaciones para ML Insights urgentes
 * Detecta insights nuevos high/critical y actualiza contadores
 */

import { useEffect, useState } from 'react';
import { useUrgentInsights } from './useMLInsights';

export interface MLInsightsNotification {
  count: number;
  hasUrgent: boolean;
  conversationCount: number;
  pipelineCount: number;
}

/**
 * Hook principal para notificaciones de ML Insights
 *
 * Retorna contadores de insights urgentes para usar en badges del sidebar
 */
export function useMLInsightsNotifications(): MLInsightsNotification {
  const { conversationInsights, pipelineInsights, totalCount } = useUrgentInsights(50);

  const [previousCount, setPreviousCount] = useState(totalCount);

  // Detect new insights
  useEffect(() => {
    if (totalCount > previousCount && previousCount > 0) {
      // New urgent insights detected
      // You can trigger a toast notification here
      console.log(`🔥 ${totalCount - previousCount} nuevo(s) insight(s) urgente(s)!`);
    }
    setPreviousCount(totalCount);
  }, [totalCount, previousCount]);

  return {
    count: totalCount,
    hasUrgent: totalCount > 0,
    conversationCount: conversationInsights.data?.count || 0,
    pipelineCount: pipelineInsights.data?.count || 0,
  };
}

/**
 * Hook for sidebar badge
 * Returns the count to show in the ML Insights sidebar item
 */
export function useMLInsightsBadge(): number | string | undefined {
  const { count, hasUrgent } = useMLInsightsNotifications();

  if (!hasUrgent) return undefined;
  if (count > 99) return '99+';
  return count;
}
